import axios from '@/plugins/http.js'

export function deleteVideo (videoId) {
  const api = `/api/v1/preview-videos/${videoId}`
  const resp = axios.delete(api)
  return resp.data
}
